import { useState, useEffect } from 'react';
import { useUser } from '../UserContext';

const useUserRole = (selectedLeague) => {
  const { user } = useUser();
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    if (selectedLeague) {
      const currentUserMember = selectedLeague.members?.find(
        member => member.userId === user._id
      );

      if (currentUserMember) {
        setUserRole(currentUserMember.role);
      } else {
        setUserRole(null);
      }
    } else {
      console.log('Selected League is undefined'); // Log if selectedLeague is undefined
    }
  }, [selectedLeague, user._id]);

  return userRole;
};

export default useUserRole;